import { useTitle } from 'react-use'
import { useCurrentOrg } from './useCurrentOrg'

export const usePageTitle = (page) => {
  const {
    org: { orgName },
  } = useCurrentOrg()
  const name = orgName ? `${page} - ${orgName}` : page
  useTitle(`${name} - Serverless`)
}
